// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__oC93o","buttons":"PendingPaymentAlert_buttons__1_A5g"};